"use strict";

export default function () {
    const cards = document.querySelectorAll(".o-equipe__card");
    const popups = document.querySelectorAll(".o-pessoa-single-popup");

    cards.forEach((item, index) => {
        item.addEventListener("click", () => {
            popups.forEach((popup) => popup.classList.remove("active"));
            popups[index].classList.add("active");
        });
    });

    const closePopup = document.querySelectorAll(".close-popup");
    closePopup.forEach((item, index) => {
        item.addEventListener("click", () => {
            popups.forEach((popup) => popup.classList.remove("active"));
        });
    });
}
